exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  text-align: center;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.sebm-google-map-container {\n  height: 218px;\n}\nmwl-gauge {\n  width: 233px;\n  height: 300px;\n  display: block;\n  padding: 10px;\n}\nmwl-gauge > .gauge > .dial {\n  stroke: #eee;\n  stroke-width: 20;\n  fill: rgba(0,0,0,0);\n}\nmwl-gauge > .gauge > .value {\n  stroke: rgb(47, 227, 255);\n  stroke-width: 20;\n  fill: rgba(0,0,0,0);\n\n}\nmwl-gauge > .gauge > .value-text {\n  fill: rgb(47, 227, 255);\n  font-family: sans-serif;\n  font-weight: bold;\n  font-size: 10em;\n \n}\n.mwlResizable {\n  box-sizing: border-box;\n  background-color: red;\n}\n#my-div{\n  margin: 0 auto;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n#re1{\n  resize: both;\n  overflow: auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n#m{\n  width:326px;\n  height:180px;\n/*   background-color: red; */\n}\n#n{\n  width:852px;\n  height:269px;\n  /* background-color:yellow; */\n  resize: both;\n  overflow: auto;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n#o{\n  resize: both;\n  overflow: auto;\n\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/dash/dash.component.css
// module id = ../../../../../src/app/dash/dash.component.css
// module chunks = main